export default {
  table: {
    id: 'Invoice nr.',
    startDate: 'Start date',
    endDate: 'End date',
    showInvoice: 'Show invoice'
  }
}